// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3W3go","description":"PatientConsentPreview_description__1log3"};